import {useRef} from 'react';
import {v4 as uuidv4} from 'uuid';

export const useDefaultPanelId = (panelId = ''): string => {
  const id = useRef<string>(panelId !== '' ? panelId : uuidv4());

  return id.current;
};
